export function getTimestampConfigsRequest(query) {
  return {
    type: '@renotarizations/GET_TIMESTAMP_CONFIGS_REQUEST',
    payload: { query },
  };
}

export function getTimestampConfigsSuccess(configs) {
  return {
    type: '@renotarizations/GET_TIMESTAMP_CONFIGS_SUCCESS',
    payload: { configs },
  };
}

export function updateTimestampConfigRequest(id, data, index, onSuccess) {
  return {
    type: '@renotarizations/UPDATE_TIMESTAMP_CONFIG_REQUEST',
    payload: { id, data, index, onSuccess },
  };
}

export function updateTimestampConfigSuccess(index, config) {
  return {
    type: '@renotarizations/UPDATE_TIMESTAMP_CONFIG_SUCCESS',
    payload: { index, config },
  };
}

export function renotarizationsFailure() {
  return {
    type: '@renotarizations/RENOTARIZATIONS_FAILURE',
  };
}
